/* eslint-disable react/no-multi-comp */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ErrorPage from '../../pages/error'

class ErrorBoundary extends Component {
  state = { error: null }

  componentDidCatch(error, info) {
    this.setState({
      error,
      info,
    })

    const { raven } = this.props.raven
    if (raven) {
      raven.captureException(error, { extra: info })
    }
  }

  render() {
    const { error, info } = this.state

    if (error) {
      return this.props.renderError({ error, info })
    }

    return this.props.children
  }
}

const ErrPage = ({ error, info }) => <ErrorPage error={error.message} />

ErrPage.propTypes = {
  error: PropTypes.any,
  info: PropTypes.any,
}

ErrorBoundary.propTypes = {
  renderError: PropTypes.func,
  children: PropTypes.node.isRequired,
  raven: PropTypes.any.isRequired,
}

ErrorBoundary.defaultProps = {
  renderError: ErrPage,
}

export default ErrorBoundary
